import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=0ce42aa3"
import script from "./accept.vue?vue&type=script&lang=ts"
export * from "./accept.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports